import { VenueMinifiedType } from '@api';
import { ActionsCell, AddressCell, formatNumber } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.COLUMNS';

type UseVenuesOverviewTableColumnsPropsType = {
  handleDeleteVenue: (id: string) => void;
};

type UseVenuesOverviewTableColumnsReturnType = {
  columns: DataTableColumn<VenueMinifiedType>[];
};

export const useVenuesOverviewTableColumns = ({
  handleDeleteVenue,
}: UseVenuesOverviewTableColumnsPropsType): UseVenuesOverviewTableColumnsReturnType => {
  const { t } = useTranslation('venues');
  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  const columns: DataTableColumn<VenueMinifiedType>[] = [
    {
      accessor: 'name',
      title: t(`${TRANS_PATH}.NAME`),
      width: 200,
      sortable: true,
    },
    {
      accessor: 'category',
      title: t(`${TRANS_PATH}.CATEGORY`),
      width: 200,
      render: (record) => t(`CATEGORIES.${record.category}`),
    },
    {
      accessor: 'address',
      title: t(`${TRANS_PATH}.ADDRESS`),
      width: 200,
      render: (record) => <AddressCell address={record.address} />,
    },
    {
      accessor: 'capacity',
      title: t(`${TRANS_PATH}.CAPACITY`),
      width: 200,
      render: (record) =>
        record.capacity ? formatNumber(record.capacity) : noDataPlaceholder,
      sortable: true,
    },
    {
      accessor: 'actions',
      title: t(`${TRANS_PATH}.ACTIONS`),
      titleStyle: { textAlign: 'center' },
      width: 100,
      render: (record) => (
        <ActionsCell.Root>
          <ActionsCell.Details to={`/venues/${record.id}`} />
          <ActionsCell.Delete onClick={() => handleDeleteVenue(record.id)} />
        </ActionsCell.Root>
      ),
    },
  ];

  return { columns };
};
